import React, { useState, useRef, useEffect } from 'react';
import ListSectionTitle from './ListSectionTitle';
import ListElement from './ListElement';

function ListSection({ type, list, handleCheckboxChange, page, itemMethods }) {
	const listRef = useRef(null);
	const [ open, openList ] = useState(true);
	const [ listHeight, setHeight ] = useState(null);

	if (type === 'fridge') {
	}

	// Set the resize observer on the ul element
	useEffect(
		() => {
			let resizeObserver = new ResizeObserver((entries) => {
				// Change the size of the section when the list changes in size for the smooth CSS transition
				for (let entry of entries) {
					setHeight(entry.contentBoxSize[0].blockSize + 52);
				}
			});

			if (listRef.current) {
				resizeObserver.observe(listRef.current);
			}
			return function cleanup() {
				resizeObserver.disconnect();
			};
		},
		[ list.length ]
	);

	const handleTitleClick = (open) => {
		openList(open);
	};

	if (!list.length) {
		return '';
	}

	return (
		<div
			className={`listSection ${open ? '' : 'listSection--closed'}`}
			style={open ? { height: listHeight } : {}}
			data-type={type}
		>
			<ListSectionTitle type={type} open={open} handleTitleClick={handleTitleClick} />

			<ul ref={listRef} className={`listSection__list ${open ? 'listSection__list--open' : ''}`}>
				{list.map((element) => {
					return (
						<ListElement
							key={element.id}
							item={element}
							handleCheckboxChange={handleCheckboxChange}
							page={page}
							itemMethods={itemMethods ? itemMethods : ''}
						/>
					);
				})}
			</ul>
		</div>
	);
}

export default ListSection;
